import "../styles/default.scss";

import { styled } from '@mui/material/styles';
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";
import React from "react";
import { compose } from "redux";

import withAnalysisCategories from "../../../../../hocs/withAnalysisCategories";
import withTranslations from "../../../../../hocs/withTranslations";

const PREFIX = 'default';

const classes = {
  select: `${PREFIX}-select`,
  outlinedInput: `${PREFIX}-outlinedInput`,
  iconOutlined: `${PREFIX}-iconOutlined`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.select}`]: {
    fontSize: "14px"
  },

  [`& .${classes.outlinedInput}`]: {
    paddingTop: "8px",
    paddingBottom: "8px"
  },

  [`& .${classes.iconOutlined}`]: {
    marginTop: "-2px"
  }
}));

const AnalysisSort = ({
  setAnalysisSort,
  analysisFilters,
  translate,
  analysisSortOptions
}) => {


  return (
    <Root className={"analysis-sort"}>
      <label className={"analysis-sort__label"} id="analysis-sort">
        {translate("analysis_sort_label")}
      </label>
      <Select
        className={classes.select}
        labelId={"analysis-sort"}
        value={analysisFilters.sort ?? analysisSortOptions?.[0]?.value}
        onChange={event => {
          const value = event.target.value;

          if (typeof value === "string") {
            setAnalysisSort(value);
          }
        }}
        variant={"outlined"}
        input={<OutlinedInput classes={{ input: classes.outlinedInput }} />}
        inputProps={{
          classes: {
            iconOutlined: classes.iconOutlined
          }
        }}
      >
        {analysisSortOptions.map(({ label, value }) => {
          return (
            <MenuItem
              key={value}
              value={value}
              className="analysis-sort__option"
            >
              {translate(label)}
            </MenuItem>
          );
        })}
      </Select>
    </Root>
  );
};

AnalysisSort.propTypes = {
  analysisCategories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ),
  analysisFilters: PropTypes.shape({
    sort: PropTypes.string
  }),
  analysisSortOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ),
  setAnalysisSort: PropTypes.func
};

export default compose(withAnalysisCategories, withTranslations)(AnalysisSort);
